import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminGpsmap943xsv = () => {
  // Get the product data directly from screensData
  const productId = "gpsmap-943xsv";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminGpsmap943xsv - Direct Import - Product Data:', productData);
  console.log('GarminGpsmap943xsv - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-gpsmap-943xsv.jpg";
  
  // Force EXACT matching only - no fuzzy matching
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-943xsv"
      productName="Garmin GPSMAP 943xsv"
      productImage={imageUrl}
      csvLookupId="GPSMAP 943xsv"
      csvExactMatchOnly={true}
      componentType="screen"
    />
  );
};

export default GarminGpsmap943xsv; 